import axios from 'axios';
// config
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { HOST_API } from '../config';
import { setSession } from "./jwt";

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

axiosInstance.interceptors.request.use(
  (config) => 
    // Do something before request is sent
     config
  ,
  (error) => 
    // Do something with request error
     Promise.reject(error)
  );

axiosInstance.interceptors.response.use(
  (response) => response,
  // eslint-disable-next-line consistent-return
  async (error) => {
    const status = error?.response?.status;

    // Global redirect for 400 Bad Request
    if (status === 400) {
      window.location.href = '/dashboard/400';
      return new Promise(() => {}); // Prevent further .catch() handling
    }

    // Global redirect for 403 Forbidden
    if (status === 403) {
      sessionStorage.setItem('myTelecomWeb', true);
      window.location.href = '/dashboard/accessdenied';
      return new Promise(() => {});
    }

    // Global redirect for 500 Internal Server Error
    if (status === 500) {
      window.location.href = '/dashboard/500';
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

const refreshAuthLogic = async (failedRequest) => {
  const refreshToken = window.localStorage.getItem('refreshToken');

  console.log("refreshToken", refreshToken)

  return axiosInstance.post("/users/refresh",{
    refreshToken,
    client_id: "1",
    client_secret:
      "76e6ce9a7e10d26ac315b76e9fa8783f83922291db48ffd7264b8a17c22a89c1",
    rememberMe: true,
  },{ skipAuthRefresh: true })
    .then(async (tokenRefreshResponse) => {
      if (failedRequest.response.config.headers.Authorization)
        failedRequest.response.config.headers.Authorization =
          `Bearer ${tokenRefreshResponse.data.accessToken}`;

      axiosInstance.defaults.headers.common.Authorization = `Bearer ${tokenRefreshResponse.data.accessToken}`;

      setSession(tokenRefreshResponse.data.accessToken, tokenRefreshResponse.data.refreshToken);

      // console.log(tokenRefreshResponse.data.accessToken);
      return Promise.resolve();
    })
    .catch((error) => {
      // console.log("erro", error.message);
      // if (error.message.includes("invalid_token")) {
      // authContext.signOut();
      // }
      console.error("errro over here", error);
    });
};

// Instantiate the interceptor
createAuthRefreshInterceptor(axiosInstance, refreshAuthLogic, {
  pauseInstanceWhileRefreshing: true,
  retryInstance: axiosInstance,
  statusCodes: [401],
});


export default axiosInstance;
